import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../core/auth/auth.service';
import { Injectable } from '@angular/core';
import { FeedbackService } from '../core/feedback/feedback.service';
import { StudentService } from '../pages/student/student.service';
import { StudentModel } from '@generativ/much-smarter-models';

@Injectable({ providedIn: 'root' })
export class IsAuthorizedGuard  {

  constructor(
    private authService: AuthService,
    private feedbackService: FeedbackService,
    private router: Router,
    private studentService: StudentService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    if (
      !this.authService.isAuthenticated()
      && next.queryParams.tokenId
    ) {
      localStorage.setItem('tokenId', next.queryParams.tokenId);
      this.authService.token = next.queryParams.tokenId;
      this.studentService.getProfile()
        .subscribe({
          next: student => {
            if (student) {
              this.authService.setCurrentStudent(student);
              const redirectUrl = `/login/location-and-game`;
              this.router.navigate([redirectUrl]);
            } else {
              this.authService.setCurrentStudent(new StudentModel().parse(student));
              this.router.navigate(['/signup/demographics']);
            }
            return false;
          },
          error: error => {
            this.feedbackService.error(error, true);
            return false;
          }
        });
    }
    return true;
  }
}
